import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '@contently/toolkit';

const AggregateEventCard = ({ bgLight, bgDark, data, title }) => {
  return <Card bgDark={bgDark} bgLight={bgLight} title={title} data={[data]} />;
};

AggregateEventCard.defaultProps = {
  bgDark: null,
  bgLight: null
};

AggregateEventCard.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.number.isRequired,
  bgDark: PropTypes.string,
  bgLight: PropTypes.string
};

export default AggregateEventCard;



// WEBPACK FOOTER //
// ./app/javascript/app/components/content_portals/aggregate_event_card.jsx